import React from "react";
import classes from "./Beacon.scss";

const Beacon = React.forwardRef((props, ref) => {
  return (
    <span
      {...props}
      ref={ref => (props.updateRef ? props.updateRef(ref) : null)}
      className={classes.beaconContainer}
    >
      <span className={classes.beaconDot}>
        <span className={classes.beaconIcon} />
      </span>
    </span>
  );
});
Beacon.displayName = "Beacon";

export default Beacon;
